import React from "react";
import {NextFont} from "next/dist/compiled/@next/font";


const MontserratFontLoader = ({variableName, font, children = null}: { children?: React.ReactNode, variableName: string, font: NextFont }) => {
	return <style dangerouslySetInnerHTML={{
		__html: `
        body {
            --font-${variableName}: ${font.style.fontFamily};
		}
	`
	}}/>
}
export default MontserratFontLoader;